import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class QuestionnaireDetailsService {

    questionnaireUrl: string = environment.questionareUrl;
    reportUrl: string = environment.reportUrl;

    constructor(private http: HttpClient) {}

    getAllSurveyList(pageNumber: number, pageSize: number, filter: string, isActive: boolean, options?): Observable<any> {
        let url = `${this.questionnaireUrl}Survey/All?PageNumber=${pageNumber}&PageSize=${pageSize}&Filters=${filter}&isActive=${isActive}`;

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&searchValue=${options.filter.value}&searchColumns=${options.filter.field}`;
            }
            if (options.moduleSearchValue) {
                url = `${url}&globalSearch=${encodeURIComponent(options.moduleSearchValue)}`;
            }
        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=lastUpdated&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    activeSurveyList(): Observable<any> {
        let url = `${this.questionnaireUrl}Survey/Active`;
        return this.http.get<any>(url);
    }

    getQuestionnaireById(id: number){
        return this.http.get<any>(`${this.questionnaireUrl}Survey/${id}`)
    }

    surveyResponse(selectedChannelId: number, fromdate?, toDate?) {

        let url = this.reportUrl + 'SurveyReport/?id=' + selectedChannelId;

        if (fromdate && toDate) {
            url = url + '&FromDate=' + fromdate + '&Todate=' + toDate;
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    addQuestionnaire(c: any) {
        return this.http.post<any>(`${this.questionnaireUrl}Survey`, c);
    }

    updateQuestionnaire(c: any) {
        return this.http.put<any>(`${this.questionnaireUrl}Survey`, c);
    }

    deleteQuestionnaire(id: number) {
        return this.http.delete<any>(`${this.questionnaireUrl}Survey/${id}`);
    }

    getQustionnaireGroupIds() {
        return this.http.get<any>(this.questionnaireUrl + 'Group');
    }

    getVisitTypes(groupId: number){
        return this.http.get<any>(`${this.questionnaireUrl}Type?groupId=${groupId}`);
    }

    updateVisitType(visitType: any) {
        return this.http.put<any>(`${this.questionnaireUrl}Type`, visitType);
    }

    getallAnswerTypes() {
        return this.http.get<any>(`${this.questionnaireUrl}FormControl`);
    }

    getallQuestionnaireQuestions(isActiveInactive: boolean) {
        return this.http.get<any>(`${this.questionnaireUrl}SurveyQuestion/GetAll?isActive=${isActiveInactive}`);
    }

    addQuestion(c: any) {
        return this.http.post<any>(`${this.questionnaireUrl}SurveyQuestion`, c);
    }

    updateQuestion(c: any) {
        return this.http.put<any>(`${this.questionnaireUrl}SurveyQuestion`, c);
    }

    questionAssociaton(questionId){
        return this.http.get<any>(`${this.questionnaireUrl}SurveyQuestion/AssociationStatus/${questionId}`)
    }

    deleteQuestion(id) {
        return this.http.delete<any>(`${this.questionnaireUrl}SurveyQuestion/${id}`);
    }

    //Question Groups
    getQuestionGroups(isActive: boolean) {
        return this.http.get<any>(`${this.questionnaireUrl}SurveyQuestionGroup?isActive=${isActive}`);
    }

    addQuestionGroup(c: any) {
        return this.http.post<any>(`${this.questionnaireUrl}SurveyQuestionGroup`, c);
    }

    updateQuestionGroup(c: any) {
        return this.http.put<any>(`${this.questionnaireUrl}SurveyQuestionGroup`, c);
    }

    getQuestionGroupDetails(questionGruopId: any){
        return this.http.get<any>(`${this.questionnaireUrl}SurveyQuestionGroup/${questionGruopId}`)
    }

    deleteQuestionGroup(id: number) {
        return this.http.delete<any>(`${this.questionnaireUrl}SurveyQuestionGroup/${id}`);
    }

    getUserGroups() {
        return this.http.get<any>(environment.appOrgUrl + "UserGroup/");
    }
}
